import React from "react";
import { Modal } from "react-bootstrap";
import "./ModalHeader.css";

// Figma Web App "header" (10245:46719). Its close-button component is
// Bootstrap's, so closeButton renders it as designed and closes via onHide.
const ModalHeader = ({ title }) => (
  <Modal.Header closeButton className="app-modal-header">
    <Modal.Title as="h5" className="app-modal-title">
      {title}
    </Modal.Title>
  </Modal.Header>
);

export default ModalHeader;
